import { render } from "./MenuTab.vue?vue&type=template&id=2ae7d7d6&scoped=true"
import script from "./MenuTab.vue?vue&type=script&lang=ts"
export * from "./MenuTab.vue?vue&type=script&lang=ts"

import "./MenuTab.vue?vue&type=style&index=0&id=2ae7d7d6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2ae7d7d6"

export default script